import React, { useState } from 'react';
import './expandableTableRow.css';

export default function ExpandableTableRow({
    children,
    expandedContent,
    isExpandable = true,
    expandIcon = "fas fa-chevron-down",
    collapseIcon = "fas fa-chevron-up",
    className = "",
    onToggle = null
}) {
    const [isExpanded, setIsExpanded] = useState(false);

    const handleToggle = () => {
        if (!isExpandable) return;

        const newExpandedState = !isExpanded;
        setIsExpanded(newExpandedState);

        if (onToggle) {
            onToggle(newExpandedState);
        }
    };

    return (
        <>
            <tr
                className={`expandable-row ${isExpandable ? 'expandable' : ''} ${className}`}
                onClick={handleToggle}
                style={{ cursor: isExpandable ? 'pointer' : 'default' }}
            >
                {children}
                {isExpandable && (
                    <td className="text-center expand-toggle">
                        <i className={isExpanded ? collapseIcon : expandIcon}></i>
                    </td>
                )}
            </tr>

            {isExpandable && isExpanded && (
                <tr className="expanded-content-row">
                    <td colSpan="100%" className="expanded-content">
                        <div className="expanded-content-wrapper">
                            {expandedContent}
                        </div>
                    </td>
                </tr>
            )}
        </>
    );
}
